import { connect } from "react-redux";
import { createSelector } from "reselect";

import { ICategoryWithRoles } from "helpers/schedule/action_bar/filters";
import { toggleRole, toggleCategory } from "actions/scheduling/filters";
import {
  selectCategoriesWithRoles,
  selectFilters,
} from "store/select/scheduling";
import { IRootStateProps } from "types/reducers";

import Filters from "components/schedule/action_bar/filters";

interface IPropsFromState {
  categoriesWithRoles: ICategoryWithRoles[];
  filters: IRootStateProps["filters"];
}

const mapStateToPropsSelector = createSelector(
  selectCategoriesWithRoles,
  selectFilters,
  (categoriesWithRoles, filters): IPropsFromState => ({
    categoriesWithRoles,
    filters,
  })
);

interface IMapDispatchToProps {
  toggleRole: (role: string) => void;
  toggleCategory: (category: string) => void;
}

const mapDispatchToProps: IMapDispatchToProps = {
  toggleCategory,
  toggleRole,
};

const FiltersContainer = connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(Filters);

export default FiltersContainer;
